import React from 'react';
import { CTA_LABEL, OFFER_ANCHOR } from './constants';
interface CTAButtonProps {
  href?: string;
  children?: React.ReactNode;
  className?: string;
}
export function CTAButton({
  href = OFFER_ANCHOR,
  children,
  className = ''
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  return <a href={href} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`block w-full rounded-xl bg-petrol px-4 py-3.5 text-center font-display text-[15px] font-extrabold uppercase leading-tight tracking-tight text-cream shadow-[0_5px_0_#04302A] transition-transform duration-150 ease-out hover:-translate-y-0.5 active:translate-y-0 sm:text-lg ${className}`} data-id="element-35" data-mp="2fzbsoeiipc3b">
      {children ?? CTA_LABEL}
    </a>;
}